import Vue from "vue";
import Router from "vue-router";
import MainView from "@/components/Main/MainView";
import Login from "@/components/Main/login";
import createUser from "@/components/Main/createUser";
import listUser from "@/components/Main/listUser";
import EdificiosView from "@/components/Main/EdificiosView";
import DisenoView from "@/components/Main/DisenoView";
import PuntoControl from "@/components/Main/PuntoControl";
import Dashboard from "@/components/Main/dashboard";
import createControlPoint from "@/components/Main/createControlPoint";
import listaTareas from "@/components/Main/listaTareas";
import updateControlPoint from "@/components/Main/updateControlPoint";
import statistic from "@/components/Main/StatisticsView";
import statisticCheckpointBuildings from "@/components/Main/statisticCheckpointBuildings";
import statisticCheckpointBuildingsHistoric from "@/components/Main/statisticCheckpointBuildingsHistoric";
import statisticReporters from "@/components/Main/StatisticsReporters";
import statisticUserHistoric from "@/components/Main/statisticUserHistoric";
import ErrorView from "@/components/Main/404";
import store from "../vuex/store";
import edificioDetalle from "@/components/Main/edificioDetalle";
import DownloadReports from "@/components/Main/DownloadReports";

Vue.use(Router);
var router = new Router({
  mode: "history",
  routes: [
    {
      path: "/404",
      name: "404",
      component: ErrorView
    },
    {
      path: "/",
      name: "login",
      component: Login,
      props: route => ({ subdomain: route.params.subdomain })
    },
    {
      path: "/main/",
      name: "MainView",
      component: MainView,
      children: [
        {
          path: "newuser",
          name: "createUser",
          component: createUser,
          meta: {
            area: "settings"
          }
        },
        {
          path: "updateuser/:id",
          name: "updateUser",
          component: createUser,
          meta: {
            area: "settings"
          }
        },
        {
          path: "listuser",
          name: "listuser",
          component: listUser,
          meta: {
            area: "settings"
          }
        },
        {
          path: "edificios",
          name: "edificios",
          component: EdificiosView,
          meta: {
            area: "settings"
          }
        },
        {
          path: "diseno",
          name: "diseno",
          component: DisenoView,
          meta: {
            area: "settings"
          }
        },
        {
          path: "puntoControl",
          name: "puntocontrol",
          component: PuntoControl,
          meta: {
            area: "puntocontrol"
          }
        },
        {
          path: "updatepuntoControl/:id",
          name: "updatepuntocontrol",
          component: updateControlPoint,
          meta: {
            area: "puntocontrol"
          }
        },
        {
          path: "dashboard",
          name: "dashboard",
          component: Dashboard,
          meta: {
            area: "dashboard"
          }
        },
        {
          path: "crearpuntocontrol",
          name: "crearpuntocontrol",
          component: createControlPoint,
          meta: {
            area: "puntocontrol"
          }
        },
        {
          path: "reporte/:id/:fk/:ts",
          name: "reporte",
          component: edificioDetalle,
          meta: {
            area: "dashboard"
          }
        },
        {
          path: "listatareas",
          name: "listatareas",
          component: listaTareas
        },
        {
          path: "statistics",
          name: "statistics",
          component: statistic,
          meta: {
            area: "statistics"
          }
        },
        {
          path: "statistics/reporters",
          name: "statisticsReporters",
          component: statisticReporters,
          meta: {
            area: "statistics"
          }
        },
        {
          path: "statistics/reporters/:id",
          name: "statisticsUserHistoric",
          component: statisticUserHistoric,
          meta: {
            area: "statistics"
          }
        },
        {
          path: "statistics/:id",
          name: "statisticCheckpointBuildings",
          component: statisticCheckpointBuildings,
          meta: {
            area: "statistics"
          }
        },
        {
          path: "statistics/:id/historic/:fk",
          name: "statisticCheckpointBuildingsHistoric",
          component: statisticCheckpointBuildingsHistoric,
          meta: {
            area: "statistics"
          }
        },
        {
          path: "businesses",
          name: "businesses",
          component: () => import("../components/Main/businessView.vue"),
          meta: {
            isMaster: true
          }
        },
        {
          path: "businessCreate",
          name: "businessCreate",
          component: () => import("../components/Main/businessCreate.vue"),
          meta: {
            isMaster: true
          }
        },
        {
          path: "businessEdit/:id",
          name: "businessEdit",
          component: () => import("../components/Main/businessCreate.vue"),
          meta: {
            isMaster: true
          }
        },
        {
          path: "usersMaster",
          name: "usersMaster",
          component: () => import("../components/Main/listUserMaster.vue"),
          meta: {
            isMaster: true
          }
        },
        {
          path: "usersMasterCreate",
          name: "usersMasterCreate",
          component: () => import("../components/Main/createUser.vue"),
          meta: {
            isMaster: true
          }
        },
        {
          path: "updateusermaster/:id",
          name: "updateUserMaster",
          component: createUser,
          meta: {
            area: "settings"
          }
        },
        {
          path: "download",
          name: "download",
          component: DownloadReports,
          meta: {
            area: "download"
          }
        },
        {
          path: "alerts",
          name: "alerts",
          redirect: { name: 'alerts-dashboard' },
          component: () => import("../components/Main/alertView.vue"),
          meta: {
            area: "alerts"
          },
          children: [
            {
              path: "alerts-list",
              name: "alerts-list",
              components: {
                alerts: () => import("../components/Main/alertList.vue")
              },
              meta: {
                area: "alerts"
              }
            },
            
            {
              path: "alerts-dashboard",
              name: "alerts-dashboard",
              components: {
                alerts: () => import("../components/Main/alertViewDashboard.vue")
              },
              meta: {
                area: "alerts"
              }
            },
            {
              path: "alerts-user-dashboard/:id",
              name: "alerts-user-dashboard",
              props: true,
              components: {
                alerts: () => import("../components/Main/alertViewDashboard.vue")
              },
              meta: {
                area: "alerts",
                hideSidebar: true
              }
            },
            {
              path: ":id",
              name: "alert-detail",
              props: true,
              components: {
                alerts: () => import("../components/Main/alertDetail.vue")
              },
              meta: {
                area: "alerts"
              }
            },
            {
              path: ":id/user/:userId",
              name: "alert-user-detail",
              props: true,
              components: {
                alerts: () => import("../components/Main/alertDetail.vue")
              },
              meta: {
                area: "alerts",
                hideSidebar: true
              }
            },
          ]
        },
        {
          path: "alerts-user/:id",
          name: "alerts-user",
          props: true,
          component: () => import("../components/Main/alertView.old.vue"),
          meta: {
            area: "alerts",
            hideSidebar: true
          }
        },
        {
          path: "indicators",
          name: "indicator",
          redirect: { name: "tasks" },
          component: () => import("../components/Main/indicatorView.vue"),
          meta: {
            area: "indicator"
          },
          children: [
            {
              path: "tasks",
              name: "tasks",
              components: {
                indicators: () => import("../components/Main/indicadoresTareas.vue")
              },
              meta: {
                area: "indicator"
              }
            },
            {
              path: "prom-time",
              name: "promtime",
              components: {
                indicators: () => import("../components/Main/indicadoresTiempoPromedio.vue")
              },
              meta: {
                area: "indicator"
              }
            },
            // {
            //   path: "total-tasks",
            //   name: "totaltasks",
            //   components:{
            //     indicators: () => import("../components/Main/IndicadoresTotalTareas.vue")
            //   },
            //   meta: {
            //     area: "indicator"
            //   }
            // }
          ]
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  console.log({ to });
  if (to.name == "login") {
    var domain = location.origin.split("//")[1].split(".");
    console.log(domain);

    var subdomain = null;
    if (domain.length >= 2) {
      subdomain = domain[0];
      if (!subdomain) {
        next(false);
      }
      if (subdomain == "prodfastfox" || subdomain == "fastfox") {
        next();
      } else if (subdomain == "www") {
        console.log("aqui");

        next(false);
      } else {
        store.dispatch("GETAPIKEY", subdomain).then(res => {
          if (res == 200) {
            next({ params: { subdomain: subdomain } });
          } else {
            next(false);
          }
        });
      }
    } else {
      next();
    }
  } else if (["alerts-user", "alert-user-detail"].includes(to.name)) {
    console.log("hacia alertas");
    next();
  } else if (to.name == "404") {
    next();
  } else if (!store.state.isMaster && ["listuser", "edificios", "diseno"].includes(to.name)) {
    next(false);
  } else {
    // store
    //   .dispatch("CURRENTUSER")
    //   .then(u => {
    //     next();
    //   })
    //   .catch(() => {
    //     next("/");
    //   });
    console.log("lolao router");
    next();
  }
});
router.onError((err) => {
  console.log("error: ", err);
  router.push({ name: "404" });
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js